import { createStore } from '@helpers/utils';

export const initialState = {
    isOpen: false,
    onClose: () => {},
    title: '',
    titleDesc: '',
    files: null,
    maxFileSize: 3,
    fileTypeAllowed: ['xls', 'xlsx', 'csv'],
    isFileError: false,
    onUploadFile: () => {},
    isUploading: false,
    isCanCancelUpload: false,
    isCancelUpload: false,
    onCancelUpload: () => {},
    uploadProgress: 0,
    uploadProgressMessage: '',
    isFinishUploading: false,
    onDownloadTemplate: () => {},
    renderContent: null,
    uploadButtonText: 'Upload File',
    isShowDownloadTemplate: true,
    helperText: {
        isShow: false,
        text: '',
        isLink: false,
        url: null,
    },
};

export const useFileUploadPopUp = createStore(initialState);
